import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Unipile from "@/services/unipile/unipile";

/**
 * Composable for deleting LinkedIn messages using TanStack Query
 */
export function useDeleteLinkedInMessage() {
  const queryClient = useQueryClient();

  const deleteMessageMutation = useMutation({
    mutationFn: async (messageId: string) => {
      const response = await Unipile.deleteMessage(messageId);
      return response.data;
    },
    onSuccess: () => {
      // Invalidate messages and conversations to refetch
      queryClient.invalidateQueries({
        queryKey: ["linkedin-messages"],
      });
      queryClient.invalidateQueries({
        queryKey: ["linkedin-chat-by-contact"],
      });
    },
  });

  return {
    deleteMessage: deleteMessageMutation.mutateAsync,
    isDeleting: deleteMessageMutation.isPending,
    deleteError: deleteMessageMutation.error,
  };
}
